import { DocumentSectionSpec } from '@/entities/templates';

/** Build section sortable IDs from sections. Uses section.code as stable ID. */
export const getSectionIds = (sections: DocumentSectionSpec[]): string[] =>
  sections.map((s, i) => s.code || `section-${i}`);
